// extracted by mini-css-extract-plugin
export default {"root":"BannerOutside-module-root","left":"BannerOutside-module-left","right":"BannerOutside-module-right"};